<div id="progress-buttons-component-wrapper">
  <div id="progress-buttons-component" [class]="customComponentClass">
    <div class="total-price" *ngIf="!nextProgress">
      <hr />
      <span class="label">{{ 'i18n.price.total' | translate }}: </span>
      <span class="price">
        {{ priceCalculationService.currentTotal.reducedAmount | priceFormat }}
      </span>
      <div class="reduction-price"
           *ngIf="priceCalculationService.currentTotal.reduction > 0">
        {{ 'i18n.price.reduction' | translate }}
        {{ priceCalculationService.currentTotal.reduction | priceFormat }}
      </div>
    </div>

    <div class="progress-buttons">

      <ng-container *ngIf="previousProgress">
        <button mat-raised-button
                class="button-previous"
                [disabled]="!progressChangeable"
                (click)="
                  trackProgressChangeStart(previousProgress.id);
                  setCurrentProgress(previousProgress.id);
                ">
          <div class="spinner-wrapper"
               *ngIf="!progressChangeable">
            <div #spinner class="spinner">
              <mat-spinner color="accent"></mat-spinner>
            </div>
          </div>
          <ng-container [ngSwitch]="previousProgress.id">
            <span class="title" translate>i18n.button.back</span>
          </ng-container>
        </button>
      </ng-container>

      <ng-container *ngIf="nextProgress">
        <button mat-raised-button
                color="primary"
                class="button-next"
                [disabled]="!progressChangeable"
                validate-design-step
                (validationDone)="setCurrentProgress(nextProgress.id)"
                (validationFailed)="onValidationFailed($event)">
          <div class="spinner-wrapper"
               *ngIf="!progressChangeable">
            <div #spinner class="spinner">
              <mat-spinner color="accent"></mat-spinner>
            </div>
          </div>
          <ng-container [ngSwitch]="nextProgress.id">
            <span class="title" translate>i18n.button.continue</span>
          </ng-container>
        </button>
      </ng-container>

      <ng-container *ngIf="!nextProgress">
        <button mat-raised-button
                validate-design-step
                finalize-design
                [disabled]="!progressChangeable"
                (finalizedDesign)="finalizationDone($event)"
                (validationFailed)="onValidationFailed($event)"
                color="primary"
                class="button-next">
          <div class="spinner-wrapper"
               *ngIf="!progressChangeable">
            <div #spinner class="spinner">
              <mat-spinner color="accent"></mat-spinner>
            </div>
          </div>
          <span class="title" translate>i18n.button.addToCart</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/progress/progress-buttons/progress-buttons.component.html